import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { useMutation } from "@apollo/client";
import { FINISH_SECTION } from "queries/mutations";
import { useHistory } from "react-router-dom";
import backArrow from '../../assets/images/left_arrow.png';

const PlayLectionVideo = ({ setHeaderTitle }) => {
  const location = useLocation();
  const history = useHistory();
  const { previewUrl, videoUrl, name, description, id } = location.state || {};

  useEffect(() => {
    if (name) {
      setHeaderTitle(name);
    }
  }, [name, setHeaderTitle]);

  const handleBack = () => {
    history.goBack() 
  };

  const [finishSection] = useMutation(FINISH_SECTION, {
    onCompleted({ finishSection }) {
      if (finishSection.userHistory) {
        console.log('Lection was finished')
      } else {
        console.log('Failed to finish the lection')
      }
    },
  });

  const handleFinish = () => {
    const userId = localStorage.getItem("user_id");
    finishSection({
      variables: { userId: userId, sectionId: id },
    });
  };

  return (
    <div className="lection-video">
      <img 
        src={backArrow} 
        alt="back" 
        className="points-header-arrow" 
        onClick={handleBack} 
      />
      <video width="100%" height="240" controls poster={previewUrl} onPlay={handleFinish}>
        <source src={videoUrl} type="video/mp4" />
        <source src="movie.ogg" type="video/ogg" />
      </video>
      <div className="lection-video-title">{name}</div>
      <div className="lection-video-description">{description}</div>
    </div>
  )
}

export default PlayLectionVideo;